import React, { useState, useRef, useCallback } from "react";
import clsx from "clsx";

import {
  Button,
  styled,
  Theme,
  useMediaQuery,
  Menu as MenuContainer,
  MenuItem,
  Typography,
} from "@mui/material";
import EndCallIcon from "../../../icons/EndCallIcon";
import useVideoContext from "../../../hooks/useVideoContext/useVideoContext";
import { useAppState } from "../../../state";

const StyledButton = styled(Button)({
  color: "white",
  "&:hover": {
    // background: '#600101',
  },
});

export function endMeeting(roomId: string, participantSid: string) {
  const api_key = window.sessionStorage.getItem("m_key");
  const m_key = api_key ? api_key : "";

  return fetch(
    `${process.env.REACT_APP_API_BASE_URL}/internal/room/${roomId}/status`,
    {
      method: "PUT",
      headers: {
        "content-type": "application/json",
        "X-API-KEY": m_key,
      },
      body: JSON.stringify({
        participantSid,
      }),
    }
  );
}

export default function EndCallButton(props: { className?: string }) {
  const { room } = useVideoContext();
  const localParticipant = room!.localParticipant;

  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  const [menuOpen, setMenuOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  const { meeting } = useAppState();

  const stopMeeting = useCallback(() => {
    return endMeeting(room!.sid, localParticipant!.sid).then(async (res) => {
      // console.log("endMeeting--res", res);
      const json = await res.json();
      // console.log("endMeeting--json", json);
    });
  }, [room, localParticipant]);

  const handleMeetingLeave = async () => {
    const api_key = window.sessionStorage.getItem("m_key");
    const m_key = api_key ? api_key : "";

    console.log("HANDLE MEETING LEAVE", room?.localParticipant?.sid);
    await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/internal/leave-meeting-socket`,
      {
        method: "POST",
        body: JSON.stringify({
          participantSid: room?.localParticipant?.sid,
        }),
        headers: {
          "content-type": "application/json",
          "X-API-KEY": m_key,
        },
      }
    );
  };

  function removeNetworkKeys() {
    const keysToRemove = ["latency", "jitter", "packetLoss"];

    keysToRemove.forEach((key) => {
      if (localStorage.getItem(key) !== null) {
        localStorage.removeItem(key);
        console.log(`${key} has been removed from localStorage.`);
      }
    });
  }

  return (
    <>
      <StyledButton
        onClick={() => setMenuOpen((isOpen) => !isOpen)}
        ref={anchorRef}
        className={props.className}
        startIcon={<EndCallIcon />}
        data-cy-disconnect
      >
        {/* Disconnect */}
      </StyledButton>
      <MenuContainer
        open={menuOpen}
        onClose={() => setMenuOpen((isOpen) => !isOpen)}
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: isMobile ? -55 : "bottom",
          horizontal: "center",
        }}
      >
        {meeting && Boolean(meeting.isChaperoning) === true && (
          <MenuItem onClick={() => stopMeeting()}>
            {/* <IconContainer>
            <SettingsIcon />
          </IconContainer> */}
            <Typography variant="body1">End Meeting For All</Typography>
          </MenuItem>
        )}

        <MenuItem
          onClick={async () => {
            // Send leave reason before disconnecting
            const participantSid = room?.localParticipant?.sid;
            if (participantSid) {
              const api_key = window.sessionStorage.getItem("m_key");
              const m_key = api_key ? api_key : "";
              try {
                await fetch(
                  `${process.env.REACT_APP_API_BASE_URL}/internal/room/participant-time-update`,
                  {
                    method: "PUT",
                    headers: {
                      "Content-Type": "application/json",
                      "X-API-KEY": m_key,
                    },
                    body: JSON.stringify({
                      participantSid,
                      leave_time: new Date().toISOString().slice(0, 19).replace("T", " "),
                      leave_reason: "manual",
                    }),
                  }
                );
              } catch (error) {
                console.error("Failed to send leave_reason:", error);
              }
            }
            room!.disconnect();
            handleMeetingLeave();
            removeNetworkKeys();
          }}
        >
          {/* <IconContainer>
            <BackgroundIcon />
          </IconContainer> */}
          <Typography variant="body1">Leave Meeting</Typography>
        </MenuItem>
      </MenuContainer>
    </>
  );
}
